'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { DEFAULT_SECTION, MENU_ITEMS } from '@/ui/segments/landing/constants';
import { IconClose } from '@/ui/segments/landing/icons/icon-close';
import { classNames } from '@/util/utils';
interface PopupMenuProps {
  className?: string;
  visible: boolean;
  onChange(visible: boolean): void;
}
export default function PopupMenu(t0) {
  const $ = _c(33);
  const {
    className,
    visible,
    onChange
  } = t0;
  const t1 = visible ? "pointer-events-auto translate-x-0 opacity-100" : "pointer-events-none translate-x-full opacity-100 lg:pointer-events-none lg:opacity-0";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = classNames(className, "fixed top-0 left-0 z-[9999] h-full w-full cursor-pointer bg-white transition-all duration-200", t1);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onChange) {
    t3 = () => onChange(false);
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onChange) {
    t4 = evt => {
      if (evt.key === "Escape") {
        onChange(false);
      }
    };
    $[5] = onChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onChange) {
    t5 = () => onChange(false);
    $[7] = onChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconClose />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <header className="absolute top-0 left-0 flex h-auto w-full justify-end"><button className="text-[1em]" type="button" aria-label="Close popup menu" onClick={t5}>{t6}</button></header>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onChange) {
    t8 = () => {
      onChange(false);
    };
    $[12] = onChange;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div>{DEFAULT_SECTION.caption}</div>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <Link className="font-title flex cursor-pointer items-center justify-between gap-4 border-none text-3xl! font-semibold" key={DEFAULT_SECTION.caption} onClick={t8} href={DEFAULT_SECTION.slug}>{t9}</Link>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== onChange) {
    t11 = MENU_ITEMS.map(item => {
      if (item.submenu) {
        return <div key={item.caption}><div className="mb-4 block h-px w-full bg-gray-200" /><div className="flex flex-col gap-y-4 text-3xl" key={item.caption}>{item.submenu.map(subItem => <Link className="font-title mt-[-1px] flex cursor-pointer items-center justify-between border-none text-3xl! font-semibold" key={subItem.slug} onClick={() => {
              onChange(false);
            }} href={subItem.slug}><div>{subItem.caption}</div></Link>)}</div></div>;
      }
      return <Link className="font-title flex cursor-pointer items-center justify-between border-none text-3xl! font-semibold" key={item.slug} onClick={() => {
        onChange(false);
      }} href={item.slug}><div>{item.caption}</div></Link>;
    });
    $[17] = onChange;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== onChange) {
    t12 = <Link className="font-title mt-[-1px] flex cursor-pointer items-center justify-between border-none text-3xl! font-semibold" onClick={() => {
      onChange(false);
    }} href="/app/virtual-lab">Login</Link>;
    $[19] = onChange;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t12) {
    t13 = <section className="absolute top-12 bottom-0 left-0 flex h-auto w-full flex-col gap-y-4 overflow-y-auto pl-8">{t10}{t11}{t12}</section>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t7) {
    t14 = <menu className="border-neutral-3 absolute top-4 right-4 bottom-4 left-4 grid h-[calc(100%-2rem)] max-h-[calc(100%-2rem)] w-[calc(100%-2rem)] grid-rows-[auto_1fr] gap-4 border bg-white">{t7}{t13}</menu>;
    $[25] = t13;
    $[26] = t7;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4) {
    t15 = <div className={t2} onClick={t3} role="dialog" onKeyDown={t4}>{t14}</div>;
    $[28] = t14;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}